import { render, staticRenderFns } from "./AlertMsg.vue?vue&type=template&id=bb797c54&"
import script from "./AlertMsg.vue?vue&type=script&lang=js&"
export * from "./AlertMsg.vue?vue&type=script&lang=js&"
import style0 from "./AlertMsg.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/musicManagement.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports